import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { serviceModelOptions } from 'src/api/types';
import { ServiceModel } from 'src/graphql/_generated';

interface ServiceModelSelectProps extends Omit<Props, 'value' | 'options'> {
  value: ServiceModel | undefined | null;
  onChange: (value: { label: string; value: ServiceModel }, meta: ActionMeta<any>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  filteredOptions?: ServiceModel[];
}

export const ServiceModelSelect: React.FC<ServiceModelSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select service model',
  filteredOptions,
  ...rest
}) => {
  const options = filteredOptions?.length
    ? serviceModelOptions.filter((option) => filteredOptions.includes(option.value))
    : serviceModelOptions;

  const selectedValue = value ? _.find(options, (o) => o.value === value) : null;

  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={selectedValue}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        onBlur={onBlur}
        inputId="service-model-select"
        name="serviceModel"
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
